// Accès à l'API SoftManage.
// En développement, les appels à /api passent par le proxy de package.json (http://localhost:4000).
// En production, REACT_APP_API_URL peut indiquer l'adresse de l'API.
const BASE = (process.env.REACT_APP_API_URL || '') + '/api';
const CLE_JETON = 'softmanage.jeton';

export function lireJeton() {
  try {
    return localStorage.getItem(CLE_JETON);
  } catch {
    return null;
  }
}

export function enregistrerJeton(jeton) {
  try {
    if (jeton) localStorage.setItem(CLE_JETON, jeton);
    else localStorage.removeItem(CLE_JETON);
  } catch {
    // stockage indisponible (navigation privée) : la session dure jusqu'au rechargement
  }
}

class ErreurApi extends Error {
  constructor(status, message, details) {
    super(message);
    this.status = status;
    this.details = details;
  }
}

/** Appelé quand la session expire (401) : l'AuthProvider s'y abonne pour déconnecter */
let surSessionExpiree = () => {};
export const definirSurSessionExpiree = (fn) => {
  surSessionExpiree = fn;
};

/**
 * Appelle l'API et renvoie le JSON de la réponse.
 * `corps` : objet (envoyé en JSON) ou FormData (envoi de fichier).
 */
export async function api(chemin, { methode = 'GET', corps, query } = {}) {
  const url = new URL(BASE + chemin, window.location.origin);
  for (const [cle, valeur] of Object.entries(query || {})) {
    if (valeur !== undefined && valeur !== null && valeur !== '') url.searchParams.set(cle, valeur);
  }

  const entetes = {};
  const jeton = lireJeton();
  if (jeton) entetes.Authorization = `Bearer ${jeton}`;
  let body;
  if (corps instanceof FormData) body = corps;
  else if (corps !== undefined) {
    entetes['Content-Type'] = 'application/json';
    body = JSON.stringify(corps);
  }

  let reponse;
  try {
    reponse = await fetch(url, { method: methode, headers: entetes, body });
  } catch {
    throw new ErreurApi(0, 'API injoignable : vérifiez que le backend est démarré (npm run dev dans backend)');
  }

  if (reponse.status === 204) return null;
  const donnees = await reponse.json().catch(() => null);
  if (!reponse.ok) {
    if (reponse.status === 401 && jeton) surSessionExpiree();
    const details = donnees?.details?.map?.((d) => (d.champ ? `${d.champ} : ${d.message}` : d.message)).join(' · ');
    throw new ErreurApi(reponse.status, [donnees?.erreur || `Erreur ${reponse.status}`, details].filter(Boolean).join(' — '), donnees?.details);
  }
  return donnees;
}
